<template>
    <div class="index" v-cloak ref="index">
        <!--<div class="header acea-row row-center-wrapper" >
        <div class="logo"><img :src="logoUrl" /></div>
        <router-link :to="'/search'" class="search acea-row row-middle">
          <span class="iconfont icon-xiazai5"></span>搜索商品
        </router-link>
      </div>-->
        <div class="slider-banner banner" v-if="banner.length > 0">
            <swiper :options="banner.length > 1 ? swiperOption : swiperOptionOne" v-if="banner.length > 0">
                <swiper-slide v-for="(item, index) in banner" :key="index">
                    <!--<router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="search acea-row row-middle"
            >-->
                    <img :src="item.pic" />
                    <!--</router-link>-->
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>

        <!-- 公告 -->
        <div class="scrolling-subtitle" v-if="announcement">
            <div class="img-wrap">
                <img :src="require('@/assets/images/index-scrolling-subtitle.png')" />
            </div>
            <span class="sub-title">{{ announcement }}</span>
        </div>

        <div class="nav acea-row" v-if="menus.length > 0">
            <router-link :to="item.wap_url ? item.wap_url : ''" class="item" v-for="(item, index) in menus" :key="index">
                <div class="pictrue"><img :src="item.pic" /></div>
                <div>{{ item.name }}</div>
            </router-link>
        </div>
        <div class="specialArea acea-row row-between-wrapper" v-if="activity.length">
            <router-link :to="activityOne.wap_link ? activityOne.wap_link : ''" class="assemble">
                <img :src="activityOne.pic" />
                <div class="text">
                    <div class="name">{{ activityOne.title }}</div>
                    <div class="infor">{{ activityOne.info }}</div>
                </div>
            </router-link>
            <div class="list acea-row row-column-between">
                <router-link :to="item.wap_link ? item.wap_link : ''" class="item" v-for="(item, index) in activity"
                    :key="index">
                    <img :src="item.pic" />
                    <div class="text">
                        <div class="name">{{ item.title }}</div>
                        <div class="infor">{{ item.info }}</div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class=" bg-color-F8F8F8 wrapper">
            <!-- <div class="title acea-row row-between-wrapper">
          <div class="text">
            <div class="name line1">商品</div>
            <div class="line1" v-if="false">{{ info.bastInfo }}</div>
          </div>
              <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'>
                  </div>
          <router-link :to="{ path: '/hot_new_goods/' + 1 }"  v-else class="more"
            >更多好物<span class="iconfont icon-jiantou"></span
          ></router-link>
        </div>
        <div class="slider-banner boutique" v-if="false">
          <swiper class="swiper-wrapper" :options="swiperBoutique">
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in info.bastBanner"
              :key="index"
            >
              <router-link :to="item.wap_link ? item.wap_link : ''"
                ><img :src="item.img"
              /></router-link>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>
        </div> -->

            <!-- 商品分类-导航栏-横向滑动 -->
            <div class="wrap-fixed">
                <div :class="{ 'hozFixed': hozFixed }" v-if="hozData.length > 0">
                    <div class="page-relative categorize-wrap">
                        <div class="movie-horizontal-scroll-bar">
                            <div class="page-inline-block horizontal-div" :class="{ 'on': currentType == ind }"
                                v-for="(item, ind) in hozData" :key="ind" @click="getTypeDataFn(item.cates_title_id)">{{
                                    item.title }}
                            </div>
                        </div>
                        <img class="page-absolute changeGrid" @click="changeStyle"
                            :src="changeGrid ? require('@/assets/images/index-change-top-bottom.png') : require('@/assets/images/index-change-left-right.png')" />
                    </div>
                </div>
                <!-- 商品分类 -->
                <div class="shop-categorize" v-else>
                    <div class="movie-box acea-row row-between row-middle default-categorize">
                        <span>全部商品</span>
                        <img @click="changeStyle"
                            :src="changeGrid ? require('@/assets/images/index-change-top-bottom.png') : require('@/assets/images/index-change-left-right.png')" />
                    </div>
                </div>
            </div>
            <div class="sort_search" v-if="search == 1">
                <div class="sort">
                    <div class="item" @click="set_where(1)">
                        价格
                        <img src="@assets/images/horn.png" v-if="price === 0" />
                        <img src="@assets/images/up.png" v-if="price === 1" />
                        <img src="@assets/images/down.png" v-if="price === 2" />
                    </div>
                    <div class="item item1" @click="set_where(2)">
                        销量
                        <img src="@assets/images/horn.png" v-if="stock === 0" />
                        <img src="@assets/images/up.png" v-if="stock === 1" />
                        <img src="@assets/images/down.png" v-if="stock === 2" />
                    </div>
                </div>
                <!-- 搜索框 -->
                <div class="searchWarp">
                    <form @submit.prevent="submitForm" action="/index">
                        <div class="search acea-row row-between-wrapper">
                            <div class="input indexSearch acea-row row-between-wrapper">
                                <span class="iconfont icon-sousuo"></span>
                                <input type="search" class="index_input" placeholder="搜索商品信息" v-model="searchList.search" />
                            </div>
                            <div style="margin-left: 0.2rem;" @click="clickSearch">搜索</div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- 列表 -->
            <GoodsList v-show="!changeGrid" :shopList="bastList" :couponsList="couponsList"></GoodsList>
            <HorizontalList v-show="changeGrid" :shopList="bastList" :couponsList="couponsList"></HorizontalList>

        </div>
        <div v-if="lovely.img">
            <div class="adver">
                <img :src="lovely.img" />
            </div>
        </div>
        <Coupon-window v-if="isNotOpenCouponWindow && tipImage" :image="tipImage" @checked="couponClose"
            @close="couponClose"></Coupon-window>

        <div class="bg-color-F8F8F8" style="height:1.2rem; text-align:center;" v-if="bastListCutAll.length > 0">
            <button @click="loadMoreData" style="margin: .3rem auto 0;" v-if="isLoadTitle">点击加载更多数据</button>
            <span style="margin: .3rem 0;" v-else>没有更多数据了</span>
        </div>


        <div class="add-cop" v-if="isOpenAddCoupon">
            <img src="@assets/images/index-add-coupon.png" @click="closeAddCouponMask(true)" />
        </div>
    </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import CouponWindow from "@components/CouponWindow";
// import {  getShare, getIndexTypeList, getTypeData, getSearchData } from "@api/public";
import { getHomeData,getIndexTypeList,getTypeData,getSearchData  } from "@api/publicZq"
import cookie from "@utils/store/cookie";
import sendVerifyCode from "@mixins/SendVerifyCode";
import GoodsList from "./components/GoodsList.vue";
import HorizontalList from "./components/HorizontalList.vue";

const HAS_COUPON_WINDOW = "has_coupon_window";
let fromRoute = null;
let current_couponId = null;// 切换专区

export default {
    name: "Index",
    components: {
        swiper,
        swiperSlide,
        CouponWindow,
        GoodsList,
        HorizontalList
    },
    mixins: [sendVerifyCode],
    props: {},
    watch: {
        $route: function (n) {
            if (n.name === "Index" && fromRoute == "User") {
                this.getDataFn();
            } else if (current_couponId != cookie.get("couponId")) {
                current_couponId = cookie.get("couponId");
                this.getDataFn();
            }
        }
    },
    data: function () {
        return {
            logoUrl: "",
            banner: [],
            menus: [],
            activity: [],
            activityOne: {},
            info: {
                fastList: [],
                bastBanner: [],
                firstList: [],
                bastList: []
            },
            keyword: "",
            //
            bastListCutAll: [],//分割开的列表数据
            bastList: [],// 当前列表数据
            bastCurrentIndex: 0,
            bastLimit: 100,
            isLoadTitle: false,
            scrollEnd: 0,
            //
            lovely: {},
            benefit: [],
            couponList: [],
            swiperOption: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true
            },
            swiperOptionOne: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                autoplay: false,
                loop: false,
                speed: 1000,
                observer: true,
                observeParents: true
            },
            swiperBoutique: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true
            },
            swiperProducts: {
                freeMode: true,
                freeModeMomentum: false,
                slidesPerView: "auto",
                observer: true,
                observeParents: true
            },
            couponsList: [],
            //
            isShowAddCoupon: false,
            isOpenAddCoupon: false,
            //不弹提示框的号段
            isNotOpenCouponWindow: true,
            // 发货提醒图片
            tipImage: "",
            // 切换列表排版
            changeGrid: false,
            // 导航条数据 测试数据
            hozData: [],
            currentType: 0,
            hozFixed: false,
            // 公告
            announcement: "",
            //区号
            block_id: "",
            price: 0,
            stock: 0,
            search: '',
            searchList: {
                sortkey: '',
                modekey: '',
                search: ''
            }
        };
    },
    mounted: function () {
        current_couponId = cookie.get("couponId");
        this.getDataFn();
    },
    methods: {
        getTypeDataFn(id) {
            this.price = 0
            this.stock = 0
            this.currentType = id;
            this.bastListCutAll = [];
            this.bastList = [];
            this.isLoadTitle = false;
            this.bastCurrentIndex = 0;
            getTypeData(this.block_id, id).then((res) => {
                if (res.status == 200) {
                    this.$set(this.info, "bastList", res.data);
                    this.cutList();
                }
            });
            this.$nextTick(() => {
                window.scrollBy({ top: 230, left: 0, behavior: "auto" });
            });
        },
        loadMoreData() {
            ++this.bastCurrentIndex;
            this.bastList = this.bastList.concat(this.bastListCutAll[this.bastCurrentIndex]);
            if (this.bastCurrentIndex >= this.bastListCutAll.length - 1) {
                this.isLoadTitle = false;
            }
        },
        changeStyle() {
            this.changeGrid = !this.changeGrid;
        },
        cutList() {
            if (this.info && this.info.bastList && this.info.bastList.length > 0) {
                let list = this.info.bastList;
                let allnum = parseInt(list.length / this.bastLimit);
                let newList = [];
                for (let i = 0; i < allnum; i++) {
                    newList.push(list.splice(0, this.bastLimit));
                }
                if (list.length > 0) newList.push(list);
                this.bastListCutAll = newList;
                this.bastList = newList[0];
                this.bastCurrentIndex = 0;
                if (this.bastListCutAll.length > 1) this.isLoadTitle = true;
                //  console.log(this.bastListCutAll,"this.bastListCutAll");
            }
        },
        // 绑手机号
        closeBindFn() {
            this.isBind = false;
        },
        getCaptBind: function () {
            let imgPath = this.imgCodeUrlces.split('?')[0] + '?id=' + parseInt(Math.random() * 100000);
            this.imgCodeUrlces = imgPath;
        },
        //排序筛选
        set_where: function (index) {
            this.searchList.search = ''
            let that = this;
            switch (index) {
                case 1:
                    this.searchList.sortkey = 'price'
                    if (that.price === 0) {
                        that.price = 1;
                        this.searchList.modekey = 'asc'
                    } else if (that.price === 1) {
                        that.price = 2
                        this.searchList.modekey = 'desc'
                    } else if (that.price === 2) {
                        that.price = 0
                        this.searchList.modekey = ''
                    }
                    that.stock = 0;
                    break;
                case 2:
                    this.searchList.sortkey = 'sales'
                    if (that.stock === 0) {
                        that.stock = 1;
                        this.searchList.modekey = 'asc'
                    }
                    else if (that.stock === 1) {
                        that.stock = 2;
                        this.searchList.modekey = 'desc'
                    }
                    else if (that.stock === 2) {
                        that.stock = 0;
                        this.searchList.modekey = ''
                    }
                    that.price = 0;
                    break;
                default:
            }
            this.getSearchData()
        },

        //
        closeAddCouponMask: function (val) {
            this.isShowAddCoupon = val;
        },
        getDataFn: async function () {
            let that = this;
            this.couponsList = [];
            this.couponList = [];
            this.banner = [];
            this.menus = [];

            this.hozData = [];
            this.currentType = 0;
            this.hozFixed = false;
            this.block_id = "";
            this.changeGrid = false;
            this.tipImage = "";

            this.info = {
                fastList: [],
                bastBanner: [],
                firstList: [],
                bastList: []
            };
            //
            this.bastListCutAll = [];
            this.bastList = [];
            this.bastCurrentIndex = 0;
            this.isLoadTitle = false;
            this.scrollEnd = 0;
            await getHomeData(24013).then(res => {
                if (res.status == 200) {
                    this.tipImage = res.data.sendImg || "";
                    // 正常
                    that.logoUrl = res.data.logoUrl;
                    that.$set(that, "banner", res.data.banner);
                    that.$set(that, "menus", res.data.menus);
                    that.$set(that, "activity", res.data.activity);
                    var activityOne = res.data.activity.shift() || {};
                    that.$set(that, "activityOne", activityOne);
                    that.$set(that, "info", res.data.info);
                    that.$set(that, "search", res.data.search)
                    // 公告
                    if (res.data.roll.length > 0) {
                        this.announcement = res.data.roll.reduce((pre, cur, i) => { return pre + cur.info + '    '; }, "") || '';
                    }
                    //
                    that.$set(
                        that,
                        "lovely",
                        res.data.lovely.length ? res.data.lovely[0] : {}
                    );
                    that.$set(that, "benefit", res.data.benefit);
                    that.$set(that, "couponList", res.data.couponList);
                    //
                    this.block_id = res.data.now_cate || "";
                    this.cutList();
                    //
                    document.title = res.data.site_name;
                }
            });
            await getIndexTypeList(this.block_id).then((res) => {
                if (res.status == 200) {
                    this.hozData = res.data;
                    this.currentType = 0;
                }
            })
            this.$scroll(this.$refs.index, this.handleScroll, this.lister);
        },
        lister(e) {
            let scrolly = e.scrollY;
            // console.log(scrolly, "滚动条--")
            if (scrolly > 250) {
                this.hozFixed = true;
            }
            if (this.hozFixed && scrolly < 240) {
                this.hozFixed = false;
            }
        },
        getSearchData() {
            let id = this.block_id
            let ids = this.currentType
            let data = this.searchList
            getSearchData(id, ids, data).then(res => {
                let datas = []
                //去掉无用数据
                res.data.forEach((item) => {
                    datas.push({
                        cate_id: item.cate_id,
                        id: item.id,
                        image: item.image,
                        ot_price: item.ot_price,
                        price: item.price,
                        sales: item.sales,
                        store_name: item.store_name,
                        unit_name: item.unit_name,
                        vip_price: item.vip_price,
                    })
                })
                this.bastList = datas
            })
        },
        clickSearch() {
            this.searchList.sortkey = ''
            this.searchList.modekey = ''
            this.price = 0,
                this.stock = 0,
                this.getSearchData()

        },
        couponClose() {
            cookie.set(HAS_COUPON_WINDOW, 1);
        },
    },
};
</script>
<style scoped lang="scss">
.wrapper {
    width: 100%;
}

// 分类导航
.default-categorize {
    padding: 0.32rem 0.32rem 0.2rem;
    height: 1.1rem;

    span {
        font-size: 0.32rem;
    }

    img {
        width: 0.36rem;
        height: 0.36rem;
    }
}

.wrap-fixed {
    height: 1.1rem;
    width: 100%;
}

.hozFixed {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 5;
}

.categorize-wrap {
    width: 100%;
    height: 1.1rem;
    padding: 0.32rem .8rem 0.32rem 0.32rem;

    .changeGrid {
        width: 0.36rem;
        height: 0.36rem;
        right: 0.32rem;
        top: 0.36rem;
    }

    .horizontal-div {
        margin-right: 0.48rem;
        color: #242424;
        font-size: 0.32rem;
    }

    .horizontal-div.on {
        color: #F6433D;
    }
}

//
.scrolling-subtitle {
    width: 100%;
    height: .5rem;
    line-height: .4rem;
    overflow: hidden;
    position: relative;

    .img-wrap {
        width: 0.66rem;
        background: #fff;
        position: absolute;
        z-index: 10;
        top: .07rem;

        img {
            margin-left: 0.32rem;
            width: 0.3rem;
            height: auto;
        }
    }

    .sub-title {
        position: absolute;
        left: 0.64rem;
        top: .04rem;
        white-space: nowrap;
        padding-left: 100%;
        animation: notice 18s 0s linear infinite both;
    }
}

@keyframes notice {
    100% {
        transform: translate3d(-100%, 0, 0);
    }
}

.add-cop {
    position: fixed;
    top: 15%;
    right: 0;
    width: 24px;
    height: 86px;
    z-index: 99;
}

.add-cop img {
    width: 100%;
    height: 100%;
    display: block;
}

.sort_search {
    display: flex;
    padding-left: 0.32rem;
    justify-content: space-between;
}

.sort {
    display: flex;
    justify-content: space-between;
}

.sort .item {
    width: 50%;
    text-align: center;
    margin-left: 0.1rem;
}

.sort .item1 {
    margin-left: 0.4rem;
}

.sort .item img {
    width: 0.15rem;
    height: 0.19rem;
    margin-left: 0.1rem;
}

.indexSearch {
    background: white;
    border-radius: 0.2rem;
}

.index_input {
    width: 3rem;
}

.searchWarp {
    margin-right: 0.32rem;
}
</style>
  